module.exports = __webpack_public_path__ + "static/media/heart.44d83407.svg";